import React, { useState } from 'react';
// import Styled from 'Styled-components';
import Styled from 'styled-components';
import Image from '../loggedout/common/Image';
import Image1 from '~images/mela-purchase/preferred-plan.png';
import SavePiggybankImage from '~images/mela-purchase/save-piggybank.svg';
import { device } from '../../utils/responsive_utilities';
import { fontQuicksand } from './mixin';
import {assetPath} from '../../utils/web-helper';
import {white} from '../loggedout/shared-styles/Colors'
const PreferredPlanModalImage = ({ image, header, title, subtitle, type }) => {
  return (
    <ImageContainer image={image}>
      <Head type={type}>{header}</Head>
      <Title type={type} dangerouslySetInnerHTML={{ __html: title }} />
      <SubTitle type={type}>{subtitle}</SubTitle>
    </ImageContainer>
  );
};
export default PreferredPlanModalImage;

export const ImageContainer = Styled.div`
  width: 23rem;
  height: 21rem;
  position: relative;
  background-image: url(${props => assetPath(props.image)});
  background-repeat: no-repeat;
  background-size: 100% 100%;
	display: inline-block;
  @media ${device.PhoneLargeScreen} {
    width: 14rem;
	  height: 14rem;
  }
  @media ${device.Phone} {
    width: 14rem;
    height: 14rem;
  }
`;

export const Head = Styled.h2`
  ${props => fontQuicksand(props.type === "small"?1.5:1.8, props.type === "small"? 1.45:2.0, 7)}
  color: ${white};
  position: absolute;
  top: ${props => props.type === "small" ? '2.7rem':'2.1rem'};
  left: ${props => props.type === "small" ? '1.7rem':'2.8rem'};
  transform: rotate(-19deg);
  @media ${device.PhoneLargeScreen} {
    ${props => fontQuicksand(props.type === "small"?1:1.28, props.type === "small"? 1.2:1.43, 7)}
    top: ${props => props.type === "small" ? '1.9rem':'1.7rem'};
    left: ${props => props.type === "small" ? '0.6rem':'1.4rem'};
  }
  @media ${device.Phone} {
    ${props => fontQuicksand(props.type === "small"?1:1.28, props.type === "small"? 1.2:1.43, 7)}
    top: ${props => props.type === "small" ? '1.9rem':'1.7rem'};
    left: ${props => props.type === "small" ? '0.6rem':'1.4rem'};
  }
`;

export const Title = Styled.p`
  ${fontQuicksand(4.0, 8.0, 7)};
  color: #fff;
  text-shadow: 0px 4px 0px rgba(0, 0, 0, 0.25);
  top: 4rem;
  left: 47%;
  transform: translateX(-50%) rotate(347deg);
  position: absolute;
  @media ${device.PhoneLargeScreen} {
    ${fontQuicksand(2.7, 4.5, 7)};
    padding: 0.8rem;
    top: 2.5rem;
  }
  @media ${device.Phone} {
    ${fontQuicksand(2.7, 4.5, 7)};
    padding: 0.8rem;
    top: 2.5rem;
  }
`;

export const SubTitle = Styled.p`
  ${fontQuicksand(1.6, 2.0, 7)};
	color: #fff;
	transform: rotate(-13deg);
	position: absolute;
	margin-left: auto;
	margin-right: auto;
	left: 0;
	right: 0;
	bottom: 8rem;
	text-align: center;
  @media ${device.PhoneLargeScreen} {
    ${fontQuicksand(1, 1, 7)}
    padding: 0.8rem;
    bottom: 4.8rem;
  }
  @media ${device.Phone} {
    ${fontQuicksand(1, 1, 7)}
    padding: 0.8rem;
    bottom: 4.8rem;
  }
`;